import { render } from "./Tags.vue?vue&type=template&id=d0306458"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"

import "./Tags.vue?vue&type=style&index=0&id=d0306458&lang=css"
script.render = render

export default script